import { useEffect, useState } from "react";
// @ts-ignore
import useSound from "use-sound";
// @ts-ignore
import countdown from "../countdown.mp3";
import { useAuthContext } from "../context/auth";

const useCountListDown = (
  initialValues: number[],
  callback: () => void,
  playSound?: boolean,
  sendToServer?: boolean,
  index?: number
) => {
  const { did, sendCurrentIndex } = useAuthContext();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [count, setCount] = useState(initialValues[0]);
  const [isRunning, setIsRunning] = useState(false);
  const [play] = useSound(countdown, {
    volume: 1,
  });

  // useEffect(() => {
  //   if (sendToServer) {
  //     console.log("send init index");
  //     sendCurrentIndex(0);
  //   } else {
  //     sendCurrentIndex(undefined);
  //   }
  // }, [sendToServer]);

  useEffect(() => {
    if (index !== undefined) {
      console.log("received index", index);
      setCurrentIndex(index);
      setCount(initialValues[index]);
    }
  }, [index]);

  const handleCurrentIndex = (index: number) => {
    setCurrentIndex(index);
    if (sendToServer) {
      console.log("send current index");
      sendCurrentIndex(index);
    }
  };

  const start = () => {
    setIsRunning(true);
  };

  const stop = () => {
    setIsRunning(false);
  };

  const reset = () => {
    handleCurrentIndex(0);
    setCount(initialValues[0]);
  };

  useEffect(() => {
    if (isRunning) {
      const timer = setInterval(() => {
        setCount((prevCount) => {
          console.log(prevCount);
          if (prevCount === 4) {
            if (playSound) {
              did === "L1" && play();
            }
          }
          if (prevCount === 0) {
            // Check if we have more values in the array
            if (currentIndex < initialValues.length - 1) {
              // Move to next value in array
              const nextIndex = currentIndex + 1;
              const nextValue = initialValues[nextIndex];

              // If next value is 0 (rest time), skip it and go to next exercise
              if (nextValue === 0) {
                if (nextIndex + 1 < initialValues.length) {
                  // There's a next exercise, skip to it
                  handleCurrentIndex(nextIndex + 1);
                  return initialValues[nextIndex + 1];
                } else {
                  // Last rest time is 0, finish the program
                  callback();
                  reset();
                  stop();
                  return initialValues[0];
                }
              } else {
                handleCurrentIndex(nextIndex);
                return nextValue;
              }
            } else {
              // We've finished all values in the array
              callback();
              reset();
              stop();
              return initialValues[0];
            }
          }
          return prevCount - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isRunning, currentIndex, initialValues, play, callback]);

  return {
    count,
    currentIndex,
    start,
    stop,
    reset,
    stopped: !isRunning,
    totalSteps: initialValues.length,
  };
};

export default useCountListDown;
